import gql from 'graphql-tag';

export const ListImportJobsQuery = gql`
  query ListImportJobsQuery {
    importjobs {
      solutionName
      startedOn
      completedOn
    }
  }
`;
